import { render, staticRenderFns } from "./CytologyResultView.vue?vue&type=template&id=79b0ce1c&scoped=true&"
import script from "./CytologyResultView.vue?vue&type=script&lang=js&"
export * from "./CytologyResultView.vue?vue&type=script&lang=js&"
import style0 from "./CytologyResultView.vue?vue&type=style&index=0&id=79b0ce1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b0ce1c",
  null
  
)

export default component.exports